module.exports = __webpack_public_path__ + "img/icon_1_color.d4b8730f.svg";